// @ts-nocheck

"use client"

import Link from "next/link"
import Image from "next/image"
import React from "react"
import "./styles.scss"

const Logo = ({ link, image, label, isMobile }) => {
    return (
        <div className="bg-[#2A3026] w-[60px] lg:w-[317px] h-[60px] lg:h-[317px] rounded-full flex flex-row justify-center items-end lg:translate-y-[-3.5rem]">
            <Link href={link || "/"} className="flex flex-row justify-center items-end w-full h-full pb-[0.5rem] lg:pb-[2.5rem]">
                <div className="relative w-[40px] lg:w-[115px] h-[40px] lg:h-[100px]">
                    <Image
                        src={image || "/images/beluxe/logo_beluxe.svg"}
                        alt={label || "Logo"}
                        layout="fill"
                        objectFit="contain"
                        lang="pl"
                        loading="eager"
                        quality={100}
                    />
                </div>
            </Link>
        </div>
    )
}

export default Logo